import { MoreActions, Stack, useBreakpointDown } from '@chronosphereio/chrono-ui';
import type { ReactNode } from 'react';

export interface QueryEditorToolbarActionsProps {
  children?: ReactNode;
}

/**
 * Right-aligned cluster of toolbar actions inside `QueryEditor.Toolbar`. Compose
 * `QueryEditor.ToolbarActionItem` + `QueryEditor.ToolbarDivider` children for
 * metrics-explorer style (query-adjacent vs navigation grouping).
 *
 * On narrow viewports (below `md`), the inline actions collapse behind a
 * `MoreActions` overflow button.
 */
export function QueryEditorToolbarActions({ children }: QueryEditorToolbarActionsProps) {
  const isNarrow = useBreakpointDown('md', { breakpointSource: 'viewport' });

  if (isNarrow) {
    return (
      <Stack direction="row" alignItems="center" sx={{ marginLeft: 'auto' }}>
        <MoreActions size="small">{children}</MoreActions>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="center" sx={{ marginLeft: 'auto' }}>
      {children}
    </Stack>
  );
}
